<template>
  <tr
    :id="id ? id : false"
    class="cat-repeater-table-row"
    :data-label="rowCaption"
  >
    <slot></slot>
  </tr>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "CatRepeaterTableRow",
  props: {
    id: {
      type: [String, Number]
    },
    rowCaption: {
      type: String,
      default: "Row",
      description: "Text caption to identify this row."
    }
  },
  methods: {}
});
</script>
